module.exports = __webpack_public_path__ + "static/media/3 PIECE SUIT.e1f494b9.svg";